/* unplugin-vue-components disabled */import { render } from "./ClassRoomDetailView.vue?vue&type=template&id=172f2018&scoped=true"
import script from "./ClassRoomDetailView.vue?vue&type=script&lang=js"
export * from "./ClassRoomDetailView.vue?vue&type=script&lang=js"

import "./ClassRoomDetailView.vue?vue&type=style&index=0&id=172f2018&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172f2018"]])

export default __exports__